// Faq JS
const faqButtons = document.querySelectorAll(".block__tabs_title");

faqButtons.forEach((button) => {
  button.addEventListener("click", () => {
    const slide = button.closest(".block__faq-slide");
    const panel = slide.querySelector(".block__faq-panel");

    if (slide.classList.contains("change_icon")) {
      // collapse
      slide.classList.remove("change_icon", "active");
      panel.style.height = panel.scrollHeight + "px"; // set fixed height first
      setTimeout(() => {
        panel.style.height = "0px"; // then collapse
      }, 10);
    } else {
      // expand
      slide.classList.add("change_icon", "active");
      panel.style.height = panel.scrollHeight + "px";
      panel.addEventListener("transitionend", function handler() {
        panel.style.height = "auto"; // switch to auto for flexibility
        panel.removeEventListener("transitionend", handler);
      });
    }
  });
});

// ✅ Open first panel in each wrapper by default
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".block__faq-list-wrapper").forEach((wrapper) => {
    const firstSlide = wrapper.querySelector(".block__faq-slide");
    if (firstSlide) {
      const firstPanel = firstSlide.querySelector(".block__faq-panel");
      firstSlide.classList.add("change_icon", "active");
      firstPanel.style.height = "auto";
    }
  });
});

// Click Event Listener for FAQ Heading
document.addEventListener("click", function (event) {
  const heading = event.target.closest(".js_faq_heading");
  if (heading) {
    const dataId = heading.getAttribute("data_id");

    // Remove active class from all headings
    document.querySelectorAll(".js_faq_heading").forEach((h) => {
      h.classList.remove("active");
    });
    heading.classList.add("active");

    const targetBlock = document.querySelector(`.block__faq-list-wrapper#${dataId}`);
    if (targetBlock) {
       
    const rect = targetBlock.getBoundingClientRect();
    const offsetPosition = rect.top + window.pageYOffset - 170;

    // window.scrollTo({
    // top: offsetPosition,
    // behavior: "smooth"
    // });


      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  }
});

if (document.querySelector(".js_faq_heading")) {
  let lastId;
  const menuItems = document.querySelectorAll(".block__faq-list-wrapper");
  const scrollItems = Array.from(menuItems);

  window.addEventListener("scroll", function () {
    const headerHeight = document.querySelector(".header")?.offsetHeight || 0;
    const extraOffset = 150; // 👈 keep this in sync with click scroll
    let cur = null;

    scrollItems.forEach((item) => {
      const rect = item.getBoundingClientRect();
      if (rect.top - headerHeight - extraOffset <= 0) {
        cur = item;
      }
    });

    const id = cur ? cur.id : "";
    if (lastId !== id) {
      lastId = id;
      document.querySelectorAll(".js_faq_heading").forEach((heading) => {
        heading.classList.remove("active");
      });

      if (cur) {
        const activeHeading = document.querySelector(
          `.js_faq_heading[data_id='${cur.id}']`
        );
        if (activeHeading) {
          activeHeading.classList.add("active");
          document.querySelector(".faq_type").innerHTML = activeHeading.innerHTML;
        }
      }
    }
  });
}



function isTabletOrMobile() {
  return window.matchMedia("(max-width: 989px)").matches;
}
if (isTabletOrMobile()) {
  const element = document.querySelector(".block__faq-category-mobile");
  element.addEventListener("click", function () {
    this.classList.toggle("active");
    var closestFaq = this.closest(".block__faq-category").querySelector(".block__faq-type-list-inner");
    if (closestFaq) {
      closestFaq.style.display =
        closestFaq.style.display === "none" || closestFaq.style.display === "" ? "flex" : "none";
    }
  });

  const element_one = document.querySelector(".block__faq-type-list-inner");
  element_one.addEventListener("click", function () {
    this.closest(".block__faq-category").querySelector(".block__faq-category-mobile").classList.toggle("active");
    this.style.display = this.style.display === "none" || this.style.display === "" ? "flex" : "none";
  });
  // Select all <li> elements inside .block__faq-type-list-inner
  const elementGetHtml = document.querySelectorAll(".block__faq-type-list-inner li");
  elementGetHtml.forEach((li) => {
    li.addEventListener("click", function () {
      var htmlContent = this.innerHTML;
      
      document.querySelector(".faq_type").innerHTML = htmlContent;
    });
  });
}

